import React from 'react';
import CardBuilderWrapped from '@ignitesales/neuro-application/src/components/questions/containers/CardBuilder.jsx';
import {FormattedMessage} from 'react-intl';

const renderModalFooterFn = ({ onSave, onClose}) => {
  const saveMessageId = 'cardBuilder.saveCard';
  const cancelMessageId = 'cardBuilder.cancelEdit';

  return  (
    <React.Fragment>
      <button type="button" className={ `btn` } onClick={onClose} aria-label="Cancel">
        <FormattedMessage id={ cancelMessageId } />
      </button>
      <button type="button" className={ `btn btn-primary` } onClick={onSave} aria-label="Save or Edit Card">
        <FormattedMessage id={ saveMessageId } />
      </button>
    </React.Fragment>
  );
};

const CardBuilder = (props) => {
  const builderKey = props.questionGroup.attributes.questionGroupKey;
  const builderOptions = props.questionGroup.questions.find(q => q.appkey === builderKey);

  // @todo Make this a standard layout inside the list component.
  const height = builderOptions.answers.length > 5 ?
      ((90 + 20) * Math.ceil(builderOptions.answers.length / 2)) + 'px' :
      ((90 + 20 ) * builderOptions.answers.length) + 'px';

  const listContainerProps = {style: { height}};

  return <CardBuilderWrapped {...{ ...props, customProps: {...props.customProps, showAllMode: true, listContainerProps, renderModalFooterFn }}} />;
};

export default CardBuilder;
